import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'

const StyledText = styled.p`
  font-size: ${(props) => props.size};
  font-weight: 700;
  color: ${(props) => props.color};
  margin: ${(props) => (props.wide ? '2rem 0 1rem -2rem' : '2rem 0 1rem')};
  ${Mq.lg} {
    font-size: ${(props) => props.theme.fontSizes[1]};
  }
  ${Mq.md} {
    font-size: ${(props) => props.theme.fontSizes[0]};
  }
  ${Mq.sm} {
    font-size: ${(props) => props.theme.fontSizes[0]};
  }
  ${Mq.xs} {
    font-size: 0.75rem;
  }
`

const Subtitle = ({ text, size, color, wide }) => {
  return (
    <StyledText size={size} color={color} wide={wide}>
      {text}
    </StyledText>
  )
}

export default Subtitle
